import React from 'react';
import { compose } from 'redux';

import CheckCoverage from './CheckCoverage';
import ValidateSim from './ValidateSim';
import ValidateDevice from './ValidateDevice';
import ValidatePort from './ValidatePort';
import withQuickSubOptions from 'decorators/withQuickSubOptions';

const QuickPreActivations = (props) => {
  return (
    <div>
      <h1>Quick Pre-Activation</h1>
      <CheckCoverage {...props} />
      <ValidateSim {...props} />
      <ValidateDevice {...props} />
      <ValidatePort {...props} />
    </div>
  );
};

export default compose(withQuickSubOptions)(QuickPreActivations);
